import { render } from "./index.vue?vue&type=template&id=e3a5b320"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/design/components/molecules/current-user-status/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e3a5b320"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e3a5b320', __exports__)) {
    api.reload('e3a5b320', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=e3a5b320", () => {
    api.rerender('e3a5b320', render)
  })

}


export default __exports__